// Central audit-reason prompt. The backend rejects audited actions that arrive
// without a "reason" (HTTP 400 {"error":"reason required"}). Rather than wire a
// modal into every one of those flows, Server.postData detects that response and
// calls promptReason(), which surfaces one shared modal (mounted once via
// <ReasonPromptHost/>), then retries the request with the reason attached.

let handler = null;

// Registered by <ReasonPromptHost/> at app startup.
export const registerReasonPrompt = (fn) => {
    handler = fn;
};

// Returns Promise<string|null> — the reason, or null if cancelled / no host mounted.
export const promptReason = (context = {}) => {
    if (typeof handler !== 'function') return Promise.resolve(null);
    return handler(context);
};
